import request from '../utils/request';
const querystring = require('querystring') 
//获取列表数据
export const fetchData = query => { 
    
    var list = request({
        url: 'haoka/hkTaskLog/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};
//开启轮询 
export const task = query => { 
    
    var list = request({
        url: '/haoka/rootTask/orderStatusCheck.do',
        method: 'post'
    });  
    return list;
};
export const taskSelect = query => { 
    
    var list = request({
        url: '/haoka/rootTask/taskSelect.do',
        method: 'post',
        params: query
    });  
    return list;
};


export const fetchData2 = query => { 
    
    var list = request({
        url: 'haoka/hkUserAccessFrom/selectAll.do',
        method: 'post',
        params: query
    }); 
    return list;
};

//'保存来源'
export const saveForm = query => { 
    
    var list = request({
        url: 'haoka/hkUserAccessFrom/insert.do',
        method: 'post',
        params: query
    }); 
    return list;
};
//清空消息
export const handDeleteAll = query => { 
    
    var list = request({
        url: 'haoka/hkTaskLog/deleteAll.do',
        method: 'post',
        params: query
    }); 
    return list;
}; 

//删除消息
export const handDeleteMore = query => { 
    
    var list = request({
        url: 'haoka/hkTaskLog/delete.do',
        method: 'post',
        params: query
    }); 
    return list;
}; 




